import { CORNERS, FIXED_INDENTS, LAYOUT } from 'vars/index'

export const SkeletonUnitCorners = {
  CORNERS_0: CORNERS.CORNERS_0,
  CORNERS_ROUND: CORNERS.CORNERS_ROUND,
} as const
export type SkeletonUnitCorners =
  (typeof SkeletonUnitCorners)[keyof typeof SkeletonUnitCorners]

export const SkeletonUnitDirection = {
  Row: 'row',
  Column: 'column',
} as const
export type SkeletonUnitDirection =
  (typeof SkeletonUnitDirection)[keyof typeof SkeletonUnitDirection]

export const SkeletonUnitJustifyContent = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
  SpaceBetween: 'space-between',
  SpaceAround: 'space-around',
  SpaceEvenly: 'space-evenly',
} as const
export type SkeletonUnitJustifyContent =
  (typeof SkeletonUnitJustifyContent)[keyof typeof SkeletonUnitJustifyContent]

export const SkeletonUnitAlignItems = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
} as const
export type SkeletonUnitAlignItems =
  (typeof SkeletonUnitAlignItems)[keyof typeof SkeletonUnitAlignItems]

export const SkeletonUnitWrap = {
  Nowrap: 'nowrap',
  Wrap: 'wrap',
  WrapReverse: 'wrap-reverse',
  Revert: 'revert',
} as const
export type SkeletonUnitWrap =
  (typeof SkeletonUnitWrap)[keyof typeof SkeletonUnitWrap]

export const SkeletonUnitAspectRatio = {
  PlayerDefault: 1.77,
} as const
export type SkeletonUnitAspectRatio =
  (typeof SkeletonUnitAspectRatio)[keyof typeof SkeletonUnitAspectRatio]

export const SkeletonUnitPaddings = {
  SIZE_10: [FIXED_INDENTS.INDENT_60, LAYOUT.HorizontalPaddings],
}
export type SkeletonUnitPadding =
  (typeof SkeletonUnitPaddings)[keyof typeof SkeletonUnitPaddings]

export const SkeletonUnitMargins = {
  SIZE_10: [
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_60,
  ],
  SIZE_20: [
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
  ],
  SIZE_30: [
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_10,
  ],
  SIZE_40: [
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
  ],
  SIZE_50: [
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_80,
  ],
  SIZE_60: [
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_10,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
  ],
  SIZE_70: [
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_40,
  ],
  SIZE_80: [
    FIXED_INDENTS.INDENT_40,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
  ],
  SIZE_90: [
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_40,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
  ],
  SIZE_100: [FIXED_INDENTS.INDENT_70, LAYOUT.HorizontalPaddings],
}
export type SkeletonUnitMargin =
  (typeof SkeletonUnitMargins)[keyof typeof SkeletonUnitMargins]
